import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Draft.css";

export default function Draft2() {
  return (
    <>
      <div className="draft-main">
        <Container>
          <Row>
            <Col>
              <ul className="navigator-arrow">
                <li>
                  <a href="/">
                    <i className="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i className="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>Thank You</li>
              </ul>
            </Col>
          </Row>
        </Container>
        <Container>
          <div className="draft-inner-main">
            <span>Greetings from JM Financial Mutual Fund.</span>
            <span>
              We note, with regret, that you have chosen to not empanel with us.
            </span>
            <span>
              However if you wish to change your mind and empanel with us then
              please <a href="/Thankyou-for-empanelment">Click Here</a>
            </span>
            <span>
              We firmly believe that the success of our Partners is our success
              and look forward to growth with you. Together.
            </span>
            <br />
            <span style={{fontWeight : "bold"}}>Mutual Fund investments are subject to market risk, read all scheme related documents carefully. </span>
          </div>
        </Container>
      </div>
    </>
  );
}
